
import {defineComponent} from "vue";
import Tooltip from "@/components/Tooltip.vue";
import Radio from "@/components/rechner/Radio.vue";
import Slider from "@/components/rechner/Slider.vue";
import SollzinsbindungTO from "@/types/SollzinsbindungTO";
import {CalcTrigger} from "@/types/CalcTrigger";
import HinweisTO from "@/types/HinweisTO";
import SliderTO from "@/types/SliderTO";
import HinweisMixin from "@/mixins/HinweisMixin";

export default defineComponent({
    name: "Sollzinsbindung",
    components: {Radio, Slider, Tooltip},
    mixins: [HinweisMixin],
    emits: ['sollzinsbindungChanged', 'volltilgungChanged'],
    data() {
        return {
            isVolltilgung: false,
            textSliderRate: "",
            textToolTipRate: "",
        }
    },
    methods: {
        onSollzinsbindungChanged(value: number) {
            this.$store.commit(CalcTrigger.SOLLZINSBINDUNG, value);
            this.$emit('sollzinsbindungChanged');
        },
        onVolltilgungChanged(event: any) {
            this.isVolltilgung = event.currentTarget.checked;
            this.$store.commit(CalcTrigger.VOLLTILGUNG, this.isVolltilgung);
            this.$emit('volltilgungChanged', this.isVolltilgung);
        },
        onRateChanged(value: number): void {
            this.hideErrors();
            this.$store.commit(CalcTrigger.RATE, value);
        },
        onRateOutOfRange(oldVal: number, newVal: number, min: number, max: number): void {
            this.sliderRate.hinweis = this.getHinweisRateInRangeGesetzt(oldVal, newVal, min, max);
        },
        hideErrors(): void {
            this.sliderRate.hinweis = {} as HinweisTO;
        }
    },
    computed: {
        isInitDataLoaded(): boolean {
            return this.$store.state.initDataLoaded;
        },
        volltilgungsoptionChecked(): boolean {
            return this.$store.state.volltilgungsoptionChecked;
        },
        volltilgungsoptionVisible(): boolean {
            return this.$store.state.volltilgungsoptionVisible;
        },
        sollzinsbindungen(): Array<SollzinsbindungTO> {
            return this.$store.state.sollzinsbindungen;
        },
        sollzinsbindungenDauer(): Array<number> {
            let dauerSollzinsbindungen = [];

            for (let i = 0; i < this.sollzinsbindungen.length; i++) {
                dauerSollzinsbindungen[i] = this.sollzinsbindungen[i].dauer;
            }
            return dauerSollzinsbindungen;
        },
        sollzinsbindungValue(): number {
            return this.$store.state.dauerSollzinsbindungDefaultValue;
        },
        textDauerSollzinsbindung(): string {
            return this.$store.state.fachtexte["rechner.berechnung.sollzinsbindung"];
        },
        textVolltilgungsoption(): string {
            return this.$store.state.fachtexte["rechner.berechnung.text.volltilgungsoption"];
        },
        textToolTipVolltilgung(): string {
            return this.$store.state.fachtexte["rechner.berechnung.tooltip.volltilgungsoption"];
        },
        sliderRate(): SliderTO {
            return this.$store.state.sliderRate;
        },
    },
    watch: {
        isInitDataLoaded(isLoaded: boolean): void {
            if (isLoaded) {
                this.textSliderRate = this.$store.state.fachtexte["rechner.berechnung.slider.rate"];
                this.textToolTipRate = this.$store.state.fachtexte["rechner.berechnung.tooltip.rate"];

                this.isVolltilgung = this.$store.state.volltilgungsoptionChecked;
            }
        },
    }
})
